<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div v-if="busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else-if="fortnox_status" class="content">
            <div class="card mb-3">
                <div class="card-header header-elements-inline bg-white">
                    <h6 class="card-title">Supékort Sweden AB</h6>
                    <div class="header-elements">
                        <a href="https://common.interstellar.newport.se/fortnox/auth/start/sht" target="_blank" class="btn btn-light btn-labeled btn-labeled-left"><b><i class="icon-user-lock"></i></b> Logga in/Skapa token</a>
                    </div>
                </div>
                <div class="card-body">
                    <div
                        v-if="(fortnox_status.sht.refresh_token && fortnox_status.sht.refresh_token > 0)"
                        class="alert alert-success alert-styled-left"
                    >
                        Fortnox-integrationen är aktiv!
                    </div>
                    <div
                        v-else
                        class="alert alert-danger alert-styled-left"
                    >
                        Fortnox-integrationen är ej aktiv, var god logga in på nytt, välj Supékort Sweden AB och godkänn behörighet.
                    </div>
                    <div>
                        <span class="font-weight-semibold">Access Token:</span> {{ fortnox_status.sht.access_token && fortnox_status.sht.access_token > 0 ? formatNumber(fortnox_status.sht.access_token/60) + ' min' : '---' }}
                    </div>
                    <div :class="{'text-danger': !(fortnox_status.sht.refresh_token && fortnox_status.sht.refresh_token > 0)}">
                        <span class="font-weight-semibold">Refresh Token:</span> {{ fortnox_status.sht.refresh_token && fortnox_status.sht.refresh_token > 0 ? formatNumber(fortnox_status.sht.refresh_token/60/60/24, 1) + ' dagar' : '---' }}
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-header header-elements-inline bg-white">
                    <h6 class="card-title">Newport Collection AB</h6>
                    <div class="header-elements">
                        <a href="https://common.interstellar.newport.se/fortnox/auth/start/npc" target="_blank" class="btn btn-light btn-labeled btn-labeled-left"><b><i class="icon-user-lock"></i></b> Logga in/Skapa token</a>
                    </div>
                </div>
                <div class="card-body">
                    <div
                        v-if="(fortnox_status.npc.refresh_token && fortnox_status.npc.refresh_token > 0)"
                        class="alert alert-success alert-styled-left"
                    >
                        Fortnox-integrationen är aktiv!
                    </div>
                    <div
                        v-else
                        class="alert alert-danger alert-styled-left"
                    >
                        Fortnox-integrationen är ej aktiv, var god logga in på nytt, välj Newport Collection AB och godkänn behörighet.
                    </div>
                    <div>
                        <span class="font-weight-semibold">Access Token:</span> {{ fortnox_status.npc.access_token && fortnox_status.npc.access_token > 0 ? formatNumber(fortnox_status.npc.access_token/60) + ' min' : '---' }}
                    </div>
                    <div :class="{'text-danger': !(fortnox_status.npc.refresh_token && fortnox_status.npc.refresh_token > 0)}">
                        <span class="font-weight-semibold">Refresh Token:</span> {{ fortnox_status.npc.refresh_token && fortnox_status.npc.refresh_token > 0 ? formatNumber(fortnox_status.npc.refresh_token/60/60/24, 1) + ' dagar' : '---' }}
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-header header-elements-inline bg-white">
                    <h6 class="card-title">Newport In & Exterior Downtown (NK)</h6>
                    <div class="header-elements">
                        <a href="https://common.interstellar.newport.se/fortnox/auth/start/nk" target="_blank" class="btn btn-light btn-labeled btn-labeled-left"><b><i class="icon-user-lock"></i></b> Logga in/Skapa token</a>
                    </div>
                </div>
                <div class="card-body">
                    <div
                        v-if="(fortnox_status.nk.refresh_token && fortnox_status.nk.refresh_token > 0)"
                        class="alert alert-success alert-styled-left"
                    >
                        Fortnox-integrationen är aktiv!
                    </div>
                    <div
                        v-else
                        class="alert alert-danger alert-styled-left"
                    >
                        Fortnox-integrationen är ej aktiv, var god logga in på nytt, välj Newport In & Exterior Downtown och godkänn behörighet.
                    </div>
                    <div>
                        <span class="font-weight-semibold">Access Token:</span> {{ fortnox_status.nk.access_token && fortnox_status.nk.access_token > 0 ? formatNumber(fortnox_status.nk.access_token/60) + ' min' : '---' }}
                    </div>
                    <div :class="{'text-danger': !(fortnox_status.nk.refresh_token && fortnox_status.nk.refresh_token > 0)}">
                        <span class="font-weight-semibold">Refresh Token:</span> {{ fortnox_status.nk.refresh_token && fortnox_status.nk.refresh_token > 0 ? formatNumber(fortnox_status.nk.refresh_token/60/60/24, 1) + ' dagar' : '---' }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content">
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import { formatNumber } from '@services/Helpers';

export default {
    name: 'AuthStatus',
    components: {
        LimitlessPageHeader,
    },
    data: () => ({
        busy_loading: true,
        fortnox_status: null,
    }),
    mounted() {
        this.getStatus();
    },
    created() {
        document.addEventListener('visibilitychange', this.updateStatus);
        document.addEventListener('focus', this.updateStatus);
    },
    destroyed() {
        window.removeEventListener('visibilitychange', this.updateStatus);
        window.removeEventListener('focus', this.updateStatus);
    },
    methods: {
        formatNumber,
        getStatus() {
            apiClient.get('/vue/fortnox/status')
                .then((response) => {
                    this.fortnox_status = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        updateStatus() {
            if (!document.hidden) {
                this.getStatus();
            }
        },
    },
};

</script>
